import { createFileRoute } from "@tanstack/react-router";
import { UserTable } from "@/admin/components/userTable";

export const Route = createFileRoute("/_auth/admin/users")({
  component: RouteComponent,
});

function RouteComponent() {
  return <UserTable />;
}
